import { render } from "./TransactionCategoryView.vue?vue&type=template&id=61d88bf4&scoped=true"
import script from "./TransactionCategoryView.vue?vue&type=script&lang=js"
export * from "./TransactionCategoryView.vue?vue&type=script&lang=js"

import "./TransactionCategoryView.vue?vue&type=style&index=0&id=61d88bf4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d88bf4"]])

export default __exports__